import * as React from 'react';

import MultiVyBase from './MultiVyBase';
import { SideBySideWidthType } from '../../Utils/ObjektVyUtils';

interface IProps<T> {
  caption?: string;
  vyProps: T;
  readonly vyer: VyListType<T>;
  vyMenu?: React.ReactElement<any>;
  sidaVidSida?: boolean;
  sideBySideWidths?: SideBySideWidthType[];
  tabbed: boolean;
}

type VyListType<T> = Array<{
  caption: string;
  comp: React.ComponentType<React.PropsWithChildren<T>>;
  collectionName: string;
}>;

export const MultiVy = <T extends {}>(props: IProps<T>) => (
  <MultiVyBase {...props} />
);

export function multiVy<T extends {}>(
  vyer: VyListType<T>
): React.FunctionComponent<React.PropsWithChildren<T>> {
  return props => <MultiVy<T> vyer={vyer} vyProps={props} tabbed={false} />;
}

/** @component */
export default MultiVy;
